export const GET_DATA = 'GET_DATA';
export const WORKER_INTERVAL = 20000;
export const DEFAULT_SUCCESS_DISPATCH_CHANNEL = '[WORKER]MESSAGE_RECEIVED';
export const DEFAULT_ERROR_DISPATCH_CHANNEL = '[WORKER]ERROR_RECEIVED';
